<!-- 修改子类弹框 -->
<template>
    <el-dialog title="修改" :visible.sync="centerDialogVisible" width="30%" center>
        <div class="container">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
                v-model="datas.budgetTitle">
            </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import PlanApi from "@/components/Api/PlanApi.js";
export default {
    components: {},
    data() {
        return {
            centerDialogVisible: false,
            datas: {},//渲染的数据
        }
    },
    computed: {},
    watch: {},
    methods: {
        init(val) {
            this.datas = val
            console.log(this.datas,'大撒打算大');
            this.centerDialogVisible = true
        },
        //保存
        save() {
            let datas = {
                "automatic": this.datas.automatic,
                "budgetDescType": this.datas.budgetDescType,
                "budgetTitle": this.datas.budgetTitle,
                "budgetTitleContent": this.datas.budgetTitleContent,
                "companyId": null,
                "id": this.datas.id ? this.datas.id : this.datas.diubId,
                "schemeId": this.datas.schemeId ? this.datas.schemeId : this.datas.code,
                "sort": this.datas.sort
            }
            new PlanApi("plan").updateDescById(datas).then((res) => {
                if (res.status == 200) {
                    this.$emit('update')
                    this.centerDialogVisible = false
                    // this.$message({
                    //     message: "修改成功！",
                    //     type: "success",
                    //     customClass: "myMessageClass"
                    // });
                } else {
                    this.$message({
                        type: "error",
                        message: res.statusText,
                    });
                }
            });
           
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style>
/* .myMessageClass {
  z-index: 3000 !important;
} */
</style>
<style lang='scss' scoped>
/deep/ .el-dialog {
    margin-left: 60% !important;

}

.container {
    padding: 20px;
}
</style>